import styled from 'styled-components';

const StyledDrawer = ComponentName => styled(ComponentName)`

    &.ant-drawer-content {
        /* width: 320px; */

        /* width is for extended drawers (eg: contact new and product new) */
        transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1) 0s, width 0.5s ease-out; 

        .ant-drawer-wrapper-body {
            height: 100%;
            overflow: auto;
        }

        .ant-drawer-body {
            padding-bottom: 56px;
            line-height: 1.5715;

            .avatar-col {
                margin-bottom: 18px;
                text-align: center;

                .avatar-uploader {
                    width: auto;
                }
            }

            .ant-row.ant-form-itemx {
                margin-bottom: 14px;
            }
        }

        .ant-drawer-footer {
            text-align: right;

            button {
                margin-right: 8px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }

    ol {
        margin-bottom: 0;
    }  
`;

export { StyledDrawer };
